import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    isSaveReady: false,
    isSaving: false,
}

export const savehandlingSlice = createSlice({
    name: 'savehandling',
    initialState,
    reducers: {
        saveToggle: (state, action) => {
            // Redux Toolkit allows us to write "mutating" logic in reducers. It
            // doesn't actually mutate the state because it uses the Immer library,
            // which detects changes to a "draft state" and produces a brand new
            // immutable state based off those changes

            state.isSaveReady = action.payload
        },
        savingToggle: (state, action) => {
            state.isSaving = action.payload
        },
    },
})

// Action creators are generated for each case reducer function
export const {
    saveToggle,
    savingToggle,
} = savehandlingSlice.actions

export default savehandlingSlice.reducer
